#import "../fragments/calendar-fragment.graphql"

mutation SelectConflictCalendar($calendar: SelectCalendarSyncCalendarInputFieldInput!) {
    selectCalendarSyncCalendar(input: {calendar: $calendar}) {
        calendars {
            ...CalendarFragment
        }
    }
}
